<ul class="space-y-1">

  @for (candidate of candidates; track candidate) {
    <li [class]="getListItemClasses(candidate, isCandidateSelected(candidate))">

      <div class="flex w-full items-center gap-2">
        <div class="img-wrapper">
          <img
            [src]="candidate.thumb_image_url || ('https://placehold.co/40x40/EEE/31343C?font=noto-sans&text=' + (candidate.product_name || ''))"
            class="product-image" alt="{{candidate.product_name}}" useImageProxy/>
        </div>

        <!-- Main content area: text + desktop price badge -->
        <div class="flex flex-col md:flex-row grow md:items-center min-w-0">
          <div class="min-w-0 flex-1">
            <!-- Product name -->
            <!-- Desktop: plain text -->
            <div class="font-semibold text-sm hidden md:block truncate">
              {{ candidate.product_name }}
            </div>

            <!-- Mobile: product name is the link -->
            <a class="font-semibold text-sm inline md:hidden truncate"
               [href]="candidate.provider_product_url"
               target="_blank"
               rel="noopener noreferrer">
              {{ candidate.product_name }}
            </a>

            <!-- Mobile: price below title/link; show offer_price if available -->
            @if (candidate.offer_price) {
              <div class="block md:hidden mt-0.5">
                <span class="badge badge-xs"
                      [ngClass]="{
                      'badge-success': isExactPriceMatch(candidate),
                      'badge-warning': !isExactPriceMatch(candidate) && isPriceWithinTolerance(candidate),
                      'badge-error': isPriceOutOfTolerance(candidate)
                    }">
                {{ candidate.offer_price | price }} {{ candidate.currency }}
              </span>
              </div>
            }

            <!-- Desktop: show the provider URL (small) -->
            <a class="hidden md:inline-block text-xs text-gray-500 truncate max-w-xs"
               [href]="candidate.provider_product_url"
               target="_blank"
               rel="noopener noreferrer">
              {{ candidate.provider_product_url }}
            </a>
          </div>

          <!-- Desktop: price badge, vertically centered and more to the right -->
          @if (candidate.offer_price) {
            <div class="hidden md:flex items-center ms-2">
              <span class="badge badge-xs"
                    [ngClass]="{
                      'badge-success': isExactPriceMatch(candidate),
                      'badge-warning': !isExactPriceMatch(candidate) && isPriceWithinTolerance(candidate),
                      'badge-error': isPriceOutOfTolerance(candidate)
                    }">
                {{ candidate.offer_price | price }} {{ candidate.currency }}
              </span>
            </div>
          }
        </div>

        <!-- Action buttons on the far right -->
        <div class="flex items-center gap-1 shrink-0">
          @if (!isCandidateSelected(candidate) && !isOneCandidateSelected()) {
            <ui-button
              [variant]="'success'"
              [size]="'sm'"
              (clicked)="selectCandidate(candidate.id)">
              <fa-icon [icon]="faCheck"></fa-icon>
            </ui-button>
          }

          @if (isCandidateSelected(candidate)) {
            <ui-button
              [variant]="'danger'"
              [size]="'sm'"
              (clicked)="resetSelection()">
              <fa-icon [icon]="faXmark"></fa-icon>
            </ui-button>
          }
        </div>
      </div>

    </li>
  }

  @if (allowSearch) {
    <ui-button
      [variant]="'secondary'"
      id="button-clear"
      fullWidth="true"
      (click)="openCatalogSearch()"
      [class.hidden]="isSearchOpen"
    >
      Search for Products
    </ui-button>
  }

</ul>
